import SLMAddressList from "containers/slm/SLMAddressList";
import React, { Component } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import 'react-table/react-table.css';
import { API } from "aws-amplify";
import axios from 'axios';
import Select from 'react-select';
import { PacmanLoader } from 'react-spinners';
const CancelToken = axios.CancelToken;
const source = CancelToken.source();



export default class SLMAddressSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            stateOptions: [],
            isLoading: false,
            selectedState: null,
            buildingName: '',
            fullAddress: '',
            street: '',
            streetext: '',
            stnolow: '',
            stnohigh: '',
            state: '',
            suburb: '',
            postcode: '',
            addressid: '',
            hardseq: '',
            floorunitno: '',
            cityscoperef: '',
            lotplan: '',
            titleref:'',
            isLoading: true,
            addresses: [],
            search_count: 0,
            filter: {}
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
    }
    

    async componentDidMount() {
        
        if (!this.props.isAuthenticated) { // if false
            return;
        }
        
        
        this.getStates({});
        document.title = "SLM Address Search";
        this.setState({ isLoading: false });      
    }

    getAddresses(filter) {
        console.log("Inside getaddresses()");

        console.log(filter);
        
        //  this.setState({ searching : true });

          return API.get("colin", "/slmaddresses", {'queryStringParameters': filter});
      
    }
    
    getStates() {
        try {
            API.get("colin", `/slmstates`, { 'cancelToken': source.token }).then((stateOptions) => {
                if (stateOptions ) {
                    this.setState(state => ({ stateOptions }));
                }
            });
        }
        catch{
            console.log("Error getting states");
        }
    }

    handleChange = event => {
        console.log("Inside handleChange");

        if (event.target.id==="addressid"){
            if (event.target.value<-2147483648 ||  event.target.value> 2147483647){
                alert("Not a valid address id");
                return
            }
        }
        this.setState({
            [event.target.id]: event.target.value
        });
        
        if (event.target.id==="stnolow" && (this.state.stnohigh===""||this.state.stnohigh===null || this.state.stnohigh<event.target.value )){
            this.setState({
                stnohigh: event.target.value
            });
        }
        
    }

    handleStateChange = (selectedState) => {
        if(selectedState){
            this.setState({ selectedState: selectedState ,state: selectedState.value, modified: true });
        }
        else{
            this.setState({ selectedState: {value: null, label: null} ,state: null, modified: true });
        }
    }
   

    async handleSubmit(event) {
        console.log("HandleSubmit");
        event.preventDefault();
        this.setState({ isLoading: true });
      
        const addresses = await this.getAddresses({
                                            buildingname: this.state.buildingName,
                                            fulladdress: this.state.fullAddress,                                 
                                            street: this.state.street,
                                            streetext: this.state.streetext,
                                            stnolow: this.state.stnolow,
                                            stnohigh: this.state.stnohigh,
                                            floorunitno: this.state.floorunitno,
                                            state: this.state.state ,
                                            suburb: this.state.suburb ,
                                            addressid: this.state.addressid,
                                            hardseq: this.state.hardseq,
                                            postcode: this.state.postcode  ,
                                            cityscoperef: this.state.cityscoperef,
                                            lotplan: this.state.lotplan,
                                            titleref: this.state.titleref           
                                        });
        this.setState({ addresses });
 

        this.setState(state => ({
                        filter : {
                            buildingname: this.state.buildingName,
                            fulladdress: this.state.fullAddress,                                 
                            street: this.state.street,
                            streetext: this.state.streetext,
                            stnolow: this.state.stnolow,
                            stnohigh: this.state.stnohigh,
                            floorunitno: this.state.floorunitno,
                            state: this.state.state ,
                            suburb: this.state.suburb ,
                            addressid: this.state.addressid,
                            hardseq: this.state.hardseq,
                            postcode: this.state.postcode  ,
                            cityscoperef: this.state.cityscoperef,
                            lotplan: this.state.lotplan,
                            titleref: this.state.titleref           
                        }
                        ,search_count: ++this.state.search_count
        }));

        this.setState({ isLoading: false });              

     }

     async clearFilters() {
        console.log("clearFilters");
        this.setState({
            buildingname: "",
            fulladdress: "",                                 
            street: "",
            streetext: "",
            stnolow: "",
            stnohigh: "",
            floorunitno: "",
            state: "",
            suburb: "",
            addressid: '',
            hardseq: '',
            postcode: "",  
            cityscoperef: "",
            lotplan: "",
            titleref:"",
            selectedState: null,
            filter: {
                user: this.props.user,
                screen: "property"
            }
        });
    }


    renderSLMAddresses() {
        return (
            <div>
                 {this.state.isLoading &&
                    <div className="outer-div"><div className='sweet-loading inner-div' >
                        <PacmanLoader
                            css="display: block;
                            margin: 0 auto;
                             border-color: red"
                        sizeUnit={"px"}
                        size={20}
                        color={'#e03c31'}
                        loading={this.state.isLoading}
                        />
                </div>
                    </div>}
                    {!this.state.isLoading &&
                <Container fluid >
                    <Row>
                        <Col sm={12} md={12} lg={12}>
                            <p><b>
                                SLM Addresses
                                </b>
                    </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3} lg={2}>
                            <Form onSubmit={this.handleSubmit}>
                            <Row>
                                <Col >
                                    <Button type="submit" size="sm" id="submit" >Search</Button>
                                </Col>
                                <Col >
                                    <Button type="button" size="sm" onClick={this.clearFilters}>Clear Filters</Button>
                                </Col>
                            </Row>
                            <hr/>
                        
                            <br/>
                            <Form.Row >

                            <Col >
                                <Form.Group controlId="buildingName">
                                    <Form.Control
                                        type="input"
                                        value={this.state.buildingName}
                                        onChange={this.handleChange}
                                        placeholder="Building Name containing"
                                    />
                                </Form.Group>
                            </Col>

                            </Form.Row>
                            {/* <Form.Row>
                            <Col >
                            <Form.Group controlId="fullAddress">
                                    <Form.Control
                                        type="input"
                                        value={this.state.fullAddress}
                                        onChange={this.handleChange}
                                        placeholder="Address (% wild card)" />
                                
                                </Form.Group>
                            </Col>
                            </Form.Row> */}
                            <Form.Row>
                            <Col lg={4}>
                                
                                <Form.Group controlId="stnolow">
                                    <Form.Control
                                        type="input"
                                        value={this.state.stnolow}
                                        onChange={this.handleChange}
                                        placeholder="St No. Low" />
                                </Form.Group>
                            </Col>
                           
                            <Col lg={4}>
                                <Form.Group controlId="stnohigh">
                                    <Form.Control
                                        type="input"
                                        value={this.state.stnohigh}
                                        onChange={this.handleChange}
                                        placeholder="St No. High" />
                                        </Form.Group>
                                    
                            </Col>
                            <Col lg={4}>
                                <Form.Group controlId="floorunitno">
                                    <Form.Control
                                        type="input"
                                        value={this.state.floorunitno}
                                        onChange={this.handleChange}
                                        placeholder="Unit" />
                                        </Form.Group>
                                    
                            </Col>
                            </Form.Row>
                              <Form.Row >
                            <Col >
                            <Form.Group controlId="street">
                                    <Form.Control
                                        type="input"
                                        value={this.state.street}
                                        onChange={this.handleChange}
                                        placeholder="Street Name starting" />
                                
                                </Form.Group>
                            </Col>
                            <Col lg={4}>
                            <Form.Group controlId="streetext">
                                    <Form.Control
                                        type="input"
                                        value={this.state.streetext}
                                        onChange={this.handleChange}
                                        placeholder="Street Ext" />
                                
                                </Form.Group>
                            </Col>
                            </Form.Row>
                            <Form.Row >
                            <Col >
                           
                            <Form.Group controlId="suburb">
                                    <Form.Control
                                        type="input"
                                        value={this.state.suburb}
                                        onChange={this.handleChange}
                                        placeholder="Suburb starting" />
                                
                                </Form.Group>
                            </Col>
                            
                            </Form.Row>
                            <Form.Row >
                            <Col >
                            <Form.Group controlId="state">
                                <Select
                                    value={this.state.selectedState}
                                    onChange={this.handleStateChange}
                                    options={this.state.stateOptions}
                                    onInputChange={this.handleInputChange}
                                    onBlur={this.handleBlur}
                                    placeholder="Select a state"
                                    isClearable
                                    
                                />
                                
                                </Form.Group>
                            </Col>
                            <Col lg={4}>
                            <Form.Group controlId="postcode">
                                    <Form.Control
                                        type="input"
                                        value={this.state.postcode}
                                        onChange={this.handleChange}
                                        placeholder="Postcode" />
                                
                                </Form.Group>
                            </Col>
                            
                            </Form.Row>

                            <Form.Row >
                            <Col lg={6}>
                            <Form.Group controlId="addressid">
                            <Form.Control
                                        type="input"
                                        value={this.state.addressid}
                                        onChange={this.handleChange}
                                        placeholder="CoLin ID" />
                                
                                </Form.Group>
                            </Col>
                            <Col lg={6}>
                            <Form.Group controlId="hardseq">
                                    <Form.Control
                                        type="input"
                                        value={this.state.hardseq}
                                        onChange={this.handleChange}
                                        placeholder="PIMs ID" />
                                
                                </Form.Group>
                            </Col>
                            
                            </Form.Row>

                            <Form.Row >
                            <Col lg={6}>
                            <Form.Group controlId="lotplan">
                            <Form.Control
                                        type="input"
                                        value={this.state.lotplan}
                                        onChange={this.handleChange}
                                        placeholder="Lot Plan containing" />
                                
                                </Form.Group>
                            </Col>
                            <Col lg={6}>
                            <Form.Group controlId="titleref">
                                    <Form.Control
                                        type="input"
                                        value={this.state.titleref}
                                        onChange={this.handleChange}
                                        placeholder="Title Reference containing" />
                                
                                </Form.Group>
                            </Col>
                            
                            </Form.Row>
                            <Form.Row >
                            <Col >
                            <Form.Group controlId="cityscoperef">
                            <Form.Control
                                        type="input"
                                        value={this.state.cityscoperef}
                                        onChange={this.handleChange}
                                        placeholder="Cityscope Reference starting" />
                                
                                </Form.Group>
                            </Col>
                            
                            </Form.Row>
                                   

                            </Form>
                        </Col>
                        <Col md={9} lg={10}>

                            <Row>
                                <Col sm={12} md={12} lg={12}>

                                    <SLMAddressList
                                        filter={this.state.filter}
                                        isAuthenticated={this.props.isAuthenticated}
                                        isLoading={this.state.isLoading}
                                        data={this.state.addresses}
                                        search_count={this.state.search_count}
                                    />

                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
    }</div>
        );
    }
  render() {
    return (

        <div className="SLMAddressSearch">
            {this.props.isAuthenticated ? this.renderSLMAddresses() : console.log("error)")}
        </div>
    );
  }
}
